<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn icon dark title="Back to main menu" @click="$router.push('/hr')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link v-if="!accessedFrom201" appId="company" pageId="employees" color="white"></help-link>
                    <!-- todo user guide for HR 201 files -->
                    <v-btn v-if="!accessedFrom201 && hasEditRights" dark icon title="Upload Employees" @click="viewUploadPage">
                        <v-icon>upload_file</v-icon>
                    </v-btn>
                    <v-btn v-if="!accessedFrom201 && hasAddRights" dark color="primary" @click="showAddUserOptions" title="Add Employee">
                        <v-icon dark>add</v-icon>&nbsp;Add&nbsp;&nbsp;
                    </v-btn>
                </v-toolbar>
            </v-card> 
            <v-alert :value="networkError" type="warning" dismissible>
                Add Member failed due to network error. Please check if you have internet connection then retry again.
            </v-alert>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>
            <v-card class="elavation-1 mt-5">
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-100 mb-10':'wp-40 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search name, email, emaployee id, status, team" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?headers_mobile:headers"
                    :items="members_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >  
                    <template v-slot:items="props">
                        <tr @click="viewUser(props.item.userId)" title="Click to view/edit details" class="clickable">
                            <td>
                                <v-chip class="user-chip-container">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td v-if="!isMobile">{{props.item.employeeId}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.employmentStatus)">{{commonfn.getStatusDescription(props.item.employmentStatus)}}</b>
                            </td>
                            <td>{{props.item.position}}</td>
                            <td v-if="!isMobile">
                                <team-chips :teams="props.item.teams"></team-chips>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >Employee details has been updated.
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-dialog v-model="dialogAddNew" persistent width="600">
            <add-member-new ref="addMemberDialogNew" :dialogAddNew.sync="dialogAddNew" @send="handleAddMemberCallback"></add-member-new>
        </v-dialog>

        <!-- TODO use OkOnly component for this dialog -->
        <v-dialog v-model="dialoagAddConfirmation" persistent width="700">
            <v-card dense class="clickable">
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">New user created</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>  
                    <v-flex xs12 sm12 style="padding: 10px;">         
                        <p>New user has been created. An onboarding instructions will be sent to the registered email.</p>
                        </v-flex>
                    </v-layout>
                </v-card-text>  
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="dialoagAddConfirmation=false" dark color="primary">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddUserOptions" persistent width="600">
            <add-user-options ref="compUserOptions" :dialogAddUserOptions.sync="dialogAddUserOptions" @send="addUserOptions"></add-user-options>
        </v-dialog>
    </v-layout>  
</template>
<script>

import commonfn from '@/common/functions'   //for refactor
import employeesApi from '@/api/employees'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasAddRights, hasEditRights } from '@/helpers/access-permissions'

export default {
    name: 'CompanyEmployees',
    metaInfo: {
        title: 'Company Employees',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View all company employees with option to assign user to other team, workshift, update personal details, and link to view user profile.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-user-options': () => import("@/components/ManageTeam/AddUserOptions"),
        'add-member-new': () => import("@/components/ManageTeam/AddMemberNew"),
        'team-chips': () => import("@/components/Common/TeamsChip"),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)
        
        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },      
            search: userPrefs.getSearchKeyword(routeName),  
            x: null,
            y: null,
            mode: null,
            dialogAdd: false,
            loading: false,
            members: [],
            snackbar: false,  
            dialogEditTeamLogo: false,
            networkError: false,
            error: false,
            errorMessage: '', 
            dialoagAddConfirmation: false,
            expand: false,
            headers: [
                {text:'Employee', align: 'left',value:'lastName', width:'15%', sortable:true},
                {text:'Employee Id', align: 'left',value:'employeeId', width:'10%', sortable:true},
                {text:'Employment', align: 'left',value:'employmentStatus', width:'10%', sortable:true},
                {text:'Position', align: 'left',value:'position', width:'10%', sortable:true},
                {text:'Teams', align: 'left',value:'teams', width:'15%', sortable:true},
            ],
            headers_mobile: [
                {text:'Employee', align: 'left',value:'lastName', width:'10%', sortable:true},
                {text:'Employment', align: 'left',value:'employmentStatus', width:'10%', sortable:true},
                {text:'Position', align: 'left',value:'position', width:'10%', sortable:true},
            ],
            dialogAddNew: false,
            dialogAddUserOptions :false,
        }
    },
    methods: {
        viewUploadPage() {            
            this.$router.push(`employees/upload`)
        },
        viewUser(userId) {
            const selectedUser = this.members_filtered.filter(x => x.userId == userId)[0]
            this.$store.commit('setSelectedTwoZeroOneUser', selectedUser)
            
            if (this.accessedFrom201) {
                this.$router.push(`201/${userId}/files`)
            } else {
                this.$router.push(`employees/${userId}`)
            }
        },
        addUserOptions(email) {
            if (email != null) this.showAddMember(email)
            else this.getMembersByCompany()
        },
        showAddUserOptions() {
            this.$refs.compUserOptions.clearForm()
            this.dialogAddUserOptions = true
        },
        showAddMember(email) {
            this.$refs.addMemberDialogNew.setParamsAdd(email)
            this.dialogAddNew=true
            this.networkError=false
        },  
        async getMembersByCompany() {
            try{
                this.loading = true
                const response = await employeesApi.getAllByPageKey(this.pageKey)
                if (response && response.status == 200) {
                    this.members = response.data.employees
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async handleAddMemberCallback(mode) { 
            this.dialogAdd = false
            this.dialogAddNew = false   

            if (mode == 'Add') this.dialoagAddConfirmation = true
            else this.snackbar = true

            this.getMembersByCompany()
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: this.accessedFrom201 ? '201 Files' : 'Employees'
        })
        
        this.getMembersByCompany()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        accessedFrom201() {
            return this.$router.currentRoute.path.includes('201')
        },
        pageKey() {
            if (this.accessedFrom201) 
                return pageKeys.hr201
            else 
                return pageKeys.employees
        },
        members_filtered() {
            let temp = this.members

            // search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase();

                temp = temp.filter(item => {
                    const firstName = item.firstName.toLowerCase().includes(searchLower)
                    const lastName = item.lastName.toLowerCase().includes(searchLower)
                    const employeeId = item.employeeId.toLowerCase().includes(searchLower)
                    const email = item.email.toLowerCase().includes(searchLower)
                    const status = commonfn.getStatusDescription(item.employmentStatus).toLowerCase().includes(searchLower)
                    const teamsMatch = Array.isArray(item.teams)
                        ? item.teams.join(', ').toLowerCase().includes(searchLower)
                        : false

                    return firstName || lastName || employeeId || email || status || teamsMatch 
                })
            }

            return temp
        },
        isMobile() {
            return window.innerWidth < 600
        },  
    }
}
</script>